<script>
const KEFU_URL = 'https://hengyuejy.com/kefu/'

export default {
  name: 'KefuWidget',
  data() {
    return { timer: null, curKey: undefined }
  },
  computed: {
    isKefuPage() {
      return this.$route.path.startsWith('/hyedu/')
    }
  },
  watch: {
    '$route.path'() { this.syncWidget() }
  },
  mounted() {
    this.syncWidget()
    // 登录/退出不一定伴随路由变化（如退出后仍停在 /hyedu/wel），轮询本地登录态兜底
    this.timer = setInterval(this.syncWidget, 1000)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    getUserInfo() {
      try {
        return JSON.parse(JSON.parse(localStorage.getItem('userInfo') || 'null'))
      } catch (e) {
        return null
      }
    },
    syncWidget() {
      const u = this.getUserInfo()
      const show = this.isKefuPage && u && u.username
      const key = show ? u.username : ''
      if (key === this.curKey) return
      this.curKey = key
      show ? this.showWidget() : this.hideWidget()
    },
    showWidget() {
      if (window.Kefu) {
        this.applyUser()
        return
      }
      if (document.querySelector('script[data-kefu-widget]')) return
      const s = document.createElement('script')
      s.src = KEFU_URL + 'widget.js'
      s.dataset.kefuWidget = '1'
      s.dataset.kefuUrl = KEFU_URL
      s.dataset.title = '恒岳教研客服'
      s.dataset.greeting = '有问题？点这里问我'
      s.onload = () => { this.curKey = undefined; this.syncWidget() }
      document.body.appendChild(s)
    },
    applyUser() {
      const u = this.getUserInfo()
      if (!window.Kefu || !u || !u.username) return
      window.Kefu.setUser({
        name: u.trueName || u.username,
        phone: u.username,
        userId: u.userId || ''
      })
      window.Kefu.close()
      const host = document.getElementById('hy-kefu-widget')
      if (host) host.style.display = ''
    },
    hideWidget() {
      if (window.Kefu) {
        window.Kefu.close()
        window.Kefu.setUser(null)
      }
      const host = document.getElementById('hy-kefu-widget')
      if (host) host.style.display = 'none'
    }
  }
}
</script>
